import { callPostApi, callDeleteApi, callGetApi } from "./api";

export async function getHolidaysCutoffList(data) {
  try {
    const response = await callPostApi({ url: "holiday-cutoff", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteHolidaysCutoff(id) {
  try {
    const response = await callDeleteApi({ url: "holiday-cutoff/delete/" + id });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDetailsHoliday(id) {
  try {
    const response = await callGetApi({ url: "holiday-cutoff/" + id });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addCutOff(data) {
  try {
    const response = await callPostApi({ url: "holiday-cutoff/add", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateCutOff(id, data) {
  try {
    const response = await callPostApi({ url: "holiday-cutoff/update/" + id, body: data });
    return response;
  } catch (error) {
    throw error;
  }
}
